import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {useReviewersLiveUpdates} from '../../../hooks/use-reviewers-live-updates'
import {pullRequestsLayoutRoute} from '../../../routes/layout-route'
import {useReviewRequestsQuery} from './route-queries'

export function useReviewers() {
  const {data: layoutData} = useRouteQuery(pullRequestsLayoutRoute, 'mainQuery')
  useReviewersLiveUpdates(layoutData?.aliveChannels)

  return useReviewRequestsQuery()
}
